export const createKlaviyoProfile = async (
  name,
  email,
  oldEmail,
  childId,
  registrationSource,
) => {
  try {
    const response = await fetch("/api/createKlaviyoProfile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        name,
        oldEmail,
        childId,
        registrationSource,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Klaviyo profile creation failed:", data);
      throw new Error(data.message || "Failed to create profile");
    }

    // console.log("✅ Klaviyo profile created:", data);
    return data;
  } catch (err) {
    console.error("🚨 Error creating Klaviyo profile:", err);
    throw err;
  }
};

export const upsertKlaviyoProfile = async (body, klaviyoEventData) => {
  console.log("# --klaviyoEventDataToAPI -->", klaviyoEventData);

  try {
    const res = await fetch("/api/upsertKlaviyoProfile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: body?.email,
        first_name: body?.first_name,
        last_name: body?.last_name,
        child_age: body?.child_age,
        klaviyoListId: klaviyoEventData,
      }),
    });

    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : {};
    } catch (e) {
      data = { message: text };
    }

    if (!res.ok) {
      console.error("Klaviyo profile upsert failed:", data);
      throw new Error(data.message || "Failed to upsert profile");
    }
    console.log("✅ Klaviyo profile upserted:", data);

    return data;
  } catch (error) {
    console.error("🚨 Error creating Klaviyo profile:", error);
    throw error;
  }
};
